import { useState } from "react";
import AuthShell from "./AuthShell";
import AuthField from "./AuthField";
import Button from "../../ui/Button";
import { portalEyebrow } from "./portalAuthCopy";
import a from "./auth.module.css";

export default function AuthLoginFlow({
  heroBadge,
  backTo,
  backLabel,
  title = "Вход",
  subtitle,
  perks: _perks,
  portalId = "patient",
  emailPlaceholder = "you@mail.ru",
  loading,
  error,
  onSubmit,
  footer,
  segment,
  navExtra: _navExtra,
}) {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");

  const submit = (e) => {
    e.preventDefault();
    onSubmit({ login: login.trim(), password });
  };

  const clubName = heroBadge || null;
  const hint =
    subtitle ||
    (clubName
      ? `Кабинет клуба «${clubName}»`
      : portalEyebrow(null, portalId));

  return (
    <AuthShell
      modern
      backTo={backTo}
      backLabel={backLabel}
      showSwitcher={false}
      showBrand
      cardTitle={title}
      hint={hint}
      segment={segment}
      footer={footer}
      clubTag={clubName}
    >
      {error ? <div className={a.errorBox}>{error}</div> : null}

      <form onSubmit={submit}>
        <AuthField
          label="Email"
          type="email"
          name="email"
          autoComplete="email"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          placeholder={emailPlaceholder}
          required
        />
        <AuthField
          label="Пароль"
          type="password"
          name="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          required
        />
        <div className={a.actions}>
          <Button type="submit" block size="lg" disabled={loading}>
            {loading ? "Вход…" : "Войти"}
          </Button>
        </div>
      </form>
    </AuthShell>
  );
}
